import { Card } from '@faceup/ui'
import { Button, Space } from '@faceup/ui-base'
import { useState } from 'react'
import SetupPaylocityModal from './SetupPaylocityModal'

type Props = {
  institution: { id: string; isPaylocityEnabled: boolean }
}

const IntegrationsCard = ({ institution }: Props) => {
  const [openSetupPaylocityModal, setOpenSetupPaylocityModal] = useState(false)

  return (
    <Card>
      <Card.Section>
        <Card.Header>Integrations</Card.Header>
        <Card.Content>
          <Space style={{ flexWrap: 'wrap' }}>
            <Button
              type={institution?.isPaylocityEnabled ? 'default' : 'primary'}
              onClick={() => setOpenSetupPaylocityModal(true)}
            >
              Setup Paylocity
            </Button>
            <SetupPaylocityModal
              open={openSetupPaylocityModal}
              onClose={() => setOpenSetupPaylocityModal(false)}
              institutionId={institution?.id}
            />
          </Space>
        </Card.Content>
      </Card.Section>
    </Card>
  )
}

export default IntegrationsCard
